import { BCMSRecord, useGlobalController, useParams, useRoute } from "@bcm-dev/bcms-vite";
import PageLayoutContainer from 'compid/shared/containers/PageLayoutContainer';
import PageView from 'compid/shared/containers/PageViewContainer';
import { Payment } from "model";
import React from "react";
import CancelledPaymentView from './components/CancelledPaymentView';
import ProcessedPaymentView from './components/ProcessedPaymentView';
import ScheduledPaymentView from './components/ScheduledPaymentView';
import "./styles.css";


/**
 * @function ViewPaymentPage
 * @return {React.Component}
 * @exported true
 * @description The main component for ViewPaymentPage
 */

export default function ViewPaymentPage(props) {
  const controller = useGlobalController();
  BCMSRecord.globalControllerFor([ Payment ], controller);
  const navigate = useRoute();
  const { paymentID } = useParams();
  const amount = "[$X.XX]";
  const accountNickname = "[AccountNickname]";
  const accountLastFour =  "[AccountLastFour]";
  const deliverDate = "[mmm d]";
  const deliverDateFinePrint = "Your check maybe cashed, and the money withdrawn from your account, before, on, or after [mmm d]."
  const withdrawnDate = "[mmm d]";
  const deliveryMethod = "[DeliveryMethod]";
  const payment = Payment.initByID(paymentID);
  const paymentStatus = payment.status.toLowerCase();
  
  return(
    <PageView className="view-payment-page">
      <p className="page-sub-header semi-bold-text">VIEW PAYMENT</p>
      <PageLayoutContainer>
        { paymentStatus === "scheduled" &&
        <ScheduledPaymentView payment={ payment } />
        }
        { paymentStatus === "processed" &&
        <ProcessedPaymentView payment={ payment } />
        }
        { paymentStatus === "canceled" &&
        <CancelledPaymentView payment={ payment } />
        }
      </PageLayoutContainer>
    </PageView>
  );
}